import React from "react";
import { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import "./DropDown.css";
import AinxtTech_logo from "../Components/images/AinxtTech_logo.png";
import { useNavigate } from "react-router-dom";
import Login from "./Login";


var Active = sessionStorage.getItem("Loggedin");

const CustomMenu = React.forwardRef(
  ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
    const [value, setValue] = useState("");
    return (
      <div
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
      >
        <Form.Control
          autoFocus
          className="mx-3 my-2 w-auto"
          placeholder="Type to filter..."
          onChange={(e) => setValue(e.target.value)}
          value={value}
        />
        <ul className="list-unstyled">
          {React.Children.toArray(children).filter(
            (child) =>
              !value || child.props?.children?.toLowerCase().startsWith(value)
          )}
        </ul>
      </div>
    );
  }
);

const DigilockerRe = () => {
  const styleObj = {
    fontSize: 15,

    color: "#FF0000",
    // textAlign: "center",
    paddingTop: "100px",
    display: "flex",
    // alignItems: "center",
    justifyContent: "center",
    height: "60vh",
  };

  const navigatePullDocument = () => {
    pull();
  };
  const navigateDowmnloadDocument = () => {
    download();
  };
  const [dates, setDates] = useState("");
  const [downloaddata, setDownloadData] = useState("");
  const [image, setImage] = useState("");
  const [showAdhaar, setshowAdhaar] = useState("");
  const [showpan, setShowPan] = useState("");
  const [showdl, setShowDl] = useState("");
  const [showudyam, setShowUdyam] = useState("");
  const [urie, Seturie] = useState("");
  const Navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const [options, setOptions] = useState({
    "Aadhaar Card": false,
    "PAN Verification Record": false,
    "Driving License": false,
    "Udyam Certificate": false,
  });
  const [box, setbox] = useState({});
  const [values, setValues] = useState({
    PandocNumber: "",
    PanName: "",
    DrivingLicenseNumber: "",
    DrivingLicenseName: "",
    UdyamNumber: "",
    UdyamName: "",
  });
  const [ adhaarxml , setAdhharXml] = useState("")

  const [panxml ,setPanXML] = useState("")
  const [ dlxml , setDLXml] = useState("")
  const {udyamXML , SetUdyamXml} = useState("")
  // const [pulldata, setPullData] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    console.log(params.get("accessRequestId"));

    const accessRequestId = params.get("accessRequestId");
    if (accessRequestId) {
      onSubmit(accessRequestId);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name);
    console.log(value);

    const formFieldsObject = {
      ...values,
      [name]: value,
    };

    setValues(formFieldsObject);
  };

const handleoptions = (options)=>{

  const value = options[options];

  const object = {

    ...options,
    [options]: !value
  }
  setOptions(object)
}


  const handleOnChange = (e) => {
    const { name, checked } = e.target;
    console.log(checked, "Dekhlo");

    const formFieldsObject = {
      ...box,
      [name]: checked,
    };
    setbox(formFieldsObject);
  };
  const Logout = () => {
    sessionStorage.clear("loggedin");
    console.log(sessionStorage);
    Navigate("/");
  };

  const onSubmit = async (accessRequestId) => {
    await fetch(
      "https://83r15wflik.execute-api.ap-south-1.amazonaws.com/v3/digilocker/documents",
      {
        method: "POST",
        body: JSON.stringify({
          consent: "Y",
          accessRequestId: accessRequestId,
        }),
        headers: {
          "x-api-key": "AEc3A0jrPy8yQcuUZvT909mu8ZV933Yd5dijiix8",
          key: "79993401FEAD58EE8B4965C62CCE60E4",
        },
      }
    )
      .then((res) => res.json())

      .then((data) => {
        console.log(data);

        setDates(data);
        Seturie(data.data.uri);
      })
      .catch((error) => console.log(error));
  };
  function menuClick() {
    var element = document.getElementById("leftMenu");
    element.classList.toggle();
    
  }

  const pull = async () => {
    const params = new URLSearchParams(window.location.search);
    const accessRequestId = params.get("accessRequestId");
    console.log(accessRequestId, "access");
    const data = {
      accessRequestId: accessRequestId,
      pullDocuments: [],
    };
    if (values.PandocNumber.trim().length !== 0 && values.name.trim().length !== 0){
     data.pullDocuments.push({ 
      docNumber: values.PandocNumber, 
      doctype: "PANCR",
      name: values.name
      
    })
    }
    if (values.DrivingLicenseNumber.trim().length !== 0 && values.DrivingLicenseName.trim().length !== 0   ){
      data.pullDocuments.push({
         dlno : values.DrivingLicenseNumber ,
          doctype: values.DrivingLicenseName
        })
     }
     if (values.udyamNumber?.trim().length !== 0 && values.UdyamName?.trim().length !== 0 ){
      data.pullDocuments.push({
        mobileNumber: values.udyamNumber,
        udyamNumber: values.UdyamName,
        doctype: "UDCER",
      })
     }
    
    console.log(data);
    await fetch(
      "https://83r15wflik.execute-api.ap-south-1.amazonaws.com/v3/digilocker/pull-document",
      {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "x-api-key": "AEc3A0jrPy8yQcuUZvT909mu8ZV933Yd5dijiix8",
          key: "79993401FEAD58EE8B4965C62CCE60E4",
        },
      }
    )
      .then((res) => res.json())

      .then((data) => {
        
        // setPullData(data);
        // Setdouri(data.result[0].uri);
      })

      .catch((error) => console.log(error)(alert("Error in Pull")));
  };

  const download = async (down) => {
    const params = new URLSearchParams(window.location.search);
    const accessRequestId = params.get("accessRequestId");
    console.log(accessRequestId, "access");
    // if(dates.data.data)
    let arrofdow = [
      {
        uri: "",
        doctype: "ADHAR",
        parsed: true,
        xml: true,
        pdf: true,
        pdfB64: true,
      },
      {
        uri: "",
        doctype: "PANCR",
        parsed: true,
        xml: true,
        pdf: true,
        pdfB64: true,
      },
      {
        uri: "",
        doctype: "UDCER",
        parsed: true,
        xml: true,
        pdf: true,
        pdfB64: true,
      },
      {
        uri: "",
        doctype: "DRVLC",
        parsed: true,
        xml: true,
        pdf: true,
        pdfB64: true,
      },
    ];

    let len = dates.data.data.length;
    for (let i = 0; i < len; i++) {
      if (
        dates.data.data[i].name === "Aadhaar Card" &&
        box.hasOwnProperty("Aadhaar Card") &&
        box["Aadhaar Card"]
      ) {
        arrofdow[0].uri = dates.data.data[i].uri;
      }
      if (
        dates.data.data[i].name === "PAN Verification Record" &&
        box.hasOwnProperty("PAN Verification Record") &&
        box["PAN Verification Record"]
      ) {
        arrofdow[1].uri = dates.data.data[i].uri;
      }
      if (
        dates.data.data[i].name === "Driving License" &&
        box.hasOwnProperty("Driving License") &&
        box["Driving License"]
      ) {
        arrofdow[2].uri = dates.data.data[i].uri;
      }

      if (
        dates.data.data[i].name === "Udyam Certificate" &&
        box.hasOwnProperty("Udyam Certificate") &&
        box["Udyam Certificate"]
      ) {
        arrofdow[3].uri = dates.data.data[i].uri;
      }
      if (i == len - 1) {
        down();
        console.log(arrofdow);
      } else if (!isChecked) {
        arrofdow.uri = "";
      }
    }
    async function down() {
      console.log(arrofdow);
      await fetch(
        "https://83r15wflik.execute-api.ap-south-1.amazonaws.com/v3/digilocker/download",
        {
          method: "POST",
          body: JSON.stringify({
            accessRequestId: accessRequestId,
            file: arrofdow,
          }),
          headers: {
            "x-api-key": "AEc3A0jrPy8yQcuUZvT909mu8ZV933Yd5dijiix8",
            key: "79993401FEAD58EE8B4965C62CCE60E4",
          },
        }
      )
        .then((res) => res.json())

        .then((data) => {
          setDownloadData(data);
          console.log(data, "DOWNLOAD");
       
          setImage(data.data.result[0].parsedFile.data.issuedTo.photo.content);
          setshowAdhaar(data.data.result[0].rawFiles.ainxtPdfB64.content);
          setShowPan(data.data.result[1].rawFiles.pdfB64.content);
          setShowDl(data.data.result[2].rawFiles.pdfB64.content);
          setShowUdyam(data.data.result[3].rawFiles.pdfB64.content);
          setAdhharXml(data.data.result[0].rawFiles.xml.content);
          setPanXML(data.data.result[1].rawFiles.xml.content);
          setDLXml(data.data.result[2].rawFiles.xml.content);
          SetUdyamXml(data.data.result[3].rawFiles.xml.content);



        });
        console.log(adhaarxml , "This is XML")
    }



  };


  return (
    <>
    
      {Active ? (
        <div>
          <div className="col-sm-6 col-8">
            <img
            
              alt="AinxtTech_Logo"
              src={AinxtTech_logo}
              width="100"
              height="auto"
              // alignItems="center"
              // justifyContent="center"
            />
          </div>
          <div style={{ position: "absolute", top: 10, right: 20 }}>
            <button className="btn btn-primary mob-w-100 " onClick={Logout}>
              Logout
            </button>
          </div>
          <div className="Pulldiv">
            <h1
              style={{
                textAlignVertical: "center",
                textAlign: "center",
                color: "red",
                top: "100%",
              }}
            >
              {" "}
              Welcome to Digilocker powered by AINXT
            </h1>

            <div></div>
            <br />
            <div
              style={{
                textAlignVertical: "center",
                textAlign: "center",
                color: "green",
              }}
            >
              <h3> Available Documents are Shown Below</h3>

              {dates?.data?.data?.map((item, index) => {
                return (
                  <div key={index}>
                    {" "}
                    <input
                      name={item.name}
                      checked={box[item.name]}
                      onChange={handleOnChange}
                      type="checkbox"
                    />{" "}
                    {item.name}{" "}
                  </div>
                );
              })}
            </div>
          

          

      
          </div>

          
              


          <div >
            {downloaddata?.data?.result?.map(
              (down, i) => {
                return (
                  <ul >
                    {" "}
                  
                   
                  </ul>
                );
              }
            )}
          </div>
          {adhaarxml?(<div onClick={menuClick}> Adhar XML
              
              <textarea name="description" value={adhaarxml}style={{ overflowx: "scroll"}}className="leftMenu">
              {adhaarxml}</textarea>
             </div>
            ):(null)}
          {!!image ? (
            <div style={{ margin: "40px" }}>
              {" "}
              <img alt="pic" src={"data:image/jpeg;base64," + image} />
            </div>
          ) : (
            ""
          )}
          {panxml?(<div onClick={menuClick}> PAN XML
              
              <textarea name="description" value={panxml} style={{ overflowx: "scroll"}}className="leftMenu">
              {panxml}</textarea>
             </div>
            ):(null)}
             {dlxml?(<div onClick={menuClick}> DL  XML
              
              <textarea name="description" value={dlxml} style={{ overflowx: "scroll"}}className="leftMenu">
              {dlxml}</textarea>
             </div>
            ):(null)}
             {udyamXML?(<div onClick={menuClick}> Udyam XML
              
              <textarea name="description" value={udyamXML} style={{  overflowX: 'scroll'}}className="leftMenu">
              {udyamXML}</textarea>
             </div>
            ):(null)}
          {!!image ? (
            <div style={{ margin: "40px" }}>
              {" "}
              <img alt="pic" src={"data:image/jpeg;base64," + image} />
            </div>
          ) : (
            ""
          )}
          



          <div> 
         

            </div> 
            

          <div>
            {!!showudyam ? (
              <div>
                <div>
                  <iframe
                    height={"400px"}
                    title="Udyam Card"
                    src={"data:application/pdf;base64," + showudyam}
                    style={{}}
                  ></iframe>
                </div>
                <div>
                  <a
                    download="Udyam Card"
                    href={"data:application/pdf;base64," + showudyam}
                    title="Download pdf document"
                  >
                    Download Udyam
                  </a>
                </div>
              </div>
            ) : (
              ""
            )}

            {!!showAdhaar ? (
              <div>
                <div>
                  <iframe
                    height={"400px"}
                    title="force"
                    src={"data:application/pdf;base64," + showAdhaar}
                    style={{}}
                  ></iframe>
                </div>
                <div>
                  <a
                    download="pdfTitle"
                    href={"data:application/pdf;base64," + showAdhaar}
                    title="Download pdf document"
                  >
                    Download Adhaar
                  </a>
                </div>
              </div>
            ) : (
              ""
            )}

            {!!showpan ? (
              <div>
                <div>
                  <iframe
                    height={"400px"}
                    title="Pan Card"
                    src={"data:application/pdf;base64," + showpan}
                    style={{}}
                  ></iframe>
                </div>
                <div>
                  <a
                    download="Pan Card"
                    href={"data:application/pdf;base64," + showpan}
                    title="Download pdf document"
                  >
                    Download PAN
                  </a>
                </div>
              </div>
            ) : (
              ""
            )}

            {!!showdl ? (
              <div>
                <div>
                  <iframe
                    height={"400px"}
                    title="Driving License"
                    src={"data:application/pdf;base64," + showdl}
                    style={{}}
                  ></iframe>
                </div>
                <div>
                  <a
                    download="Driving License"
                    href={"data:application/pdf;base64," + showdl}
                    title="Download pdf document"
                  >
                    Download DrivingLicense
                  </a>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>

      

          <div>
          
            <ul className="menu">
              <li className="menu-item">
            
             

                <div onClick={()=> {handleoptions("Adhaar Card")}}> 
                <input
                  name="name"
                  placeholder="Pan name"
                  value={values.name}
                  onChange={handleChange}
                />

                
                <input
                  name="PandocNumber"
                  placeholder="Pan number"
                  value={values.PandocNumber}
                  onChange={handleChange}
                />
                </div>
                <input
                  name="DrivingLicenseNumber"
                  placeholder="Driving License number"
                  value={values.DrivingLicenseNumber}
                  onChange={handleChange}
                />
                <input
                  name="DrivingLicenseName"
                  placeholder="Driving License name"
                  value={values.DrivingLicenseName}
                  onChange={handleChange}
                />
                <input
                  name="udyamNumber"
                  placeholder="Phone Number for Udyam"
                  value={values.udyamNumber}
                  onChange={handleChange}
                />
                <input
                  name="UdyamName"
                  placeholder="Udyam Number"
                  value={values.UdyamName}
                  onChange={handleChange}
                />
                
              </li>
              <button style={{backgroundcolor: "red" ,  color: " #e54d19", 
                    marginLeft: "auto",
                    display: "block",
                    
                    }}
                onClick={navigatePullDocument} >
                Add Documents
              </button>

              <br />
            </ul>
          </div>
        </div>
      ) : (
        <h1 style={styleObj}>
          {" "}
          <Login />
        </h1>
      )}

      return(

        <button
                  onClick={navigateDowmnloadDocument}
                  style={{
                    textAlignVertical: "center",
                    textAlign: "center",
                    alignItems:"center",
                    color: " #e54d19",
                    marginLeft: "auto",
                    display: "block",
                    
                  }}
                >
                  {" "}
                  Pull Documents
                </button>
      )
    </>
  );
};
export default DigilockerRe;
